import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { googleMapsLink } from '@/mocks/gymInfo';

export default function LocationSection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const items = el.querySelectorAll('.reveal-item');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            const index = Array.from(items).indexOf(target);
            target.style.transitionDelay = `${index * 100}ms`;
            target.classList.add('reveal-visible');
            observer.unobserve(target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="reveal-item reveal font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-950 leading-tight">
            {t('home.location.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <div className="reveal-item reveal-left flex flex-col justify-center">
            <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div>
                  <p className="font-body text-base text-foreground-950 font-medium">
                    {t('home.location.address')}
                  </p>
                  <p className="font-body text-sm text-foreground-500 mt-1">
                    {t('home.location.reference')}
                  </p>
                </div>
              </div>
              <a
                href={googleMapsLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-hover inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-900 text-background-50 font-body text-sm font-semibold px-5 py-2.5 rounded-full whitespace-nowrap"
              >
                <i className="ri-navigation-line text-base btn-icon-move"></i>
                {t('home.location.openMap')}
              </a>
            </div>
          </div>

          <div className="reveal-item reveal-right rounded-lg overflow-hidden border border-background-200">
            <iframe
              src="https://maps.google.com/maps?q=Av.+Central,+2211,+Praia+de+Cumbuco,+Caucaia,+CE,+Brazil&output=embed"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Top Gym Cumbuco - Location"
              className="w-full h-[300px] md:h-[350px]"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}